import React from "react";
import { Calendar, MessageCircle, Phone, ArrowRight } from "lucide-react";
import { CONTACT } from "@/lib/company";

export default function CtaBanner() {
  const scrollTo = (h) => document.querySelector(h)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section className="py-20 lg:py-28 relative overflow-hidden" data-testid="cta-banner">
      <div className="absolute inset-0 bg-gradient-to-br from-[#0B2D5C] via-[#081F42] to-[#050F26]"></div>
      <div className="absolute -top-32 -right-32 w-96 h-96 bg-[#C89B2C]/20 rounded-full blur-3xl"></div>
      <div className="absolute -bottom-32 -left-32 w-96 h-96 bg-[#C89B2C]/10 rounded-full blur-3xl"></div>

      <div className="max-w-5xl mx-auto px-6 lg:px-10 relative text-center reveal">
        <div className="text-xs font-semibold text-[#C89B2C] tracking-[0.25em] uppercase mb-5">
          Empecemos hoy
        </div>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-6xl font-bold text-white leading-[1.05] mb-6">
          Tu tranquilidad{" "}
          <span className="relative inline-block">
            <span className="relative z-10 text-[#C89B2C]">comienza aquí</span>
            <span className="absolute left-0 right-0 bottom-2 h-3 bg-[#C89B2C]/25 -z-0"></span>
          </span>
          .
        </h2>
        <p className="text-lg text-white/80 leading-relaxed max-w-2xl mx-auto mb-10">
          Permítenos ayudarte con tus impuestos, tu empresa o tus trámites. Estamos aquí para hacerlo simple, claro
          y profesional.
        </p>

        <div className="flex flex-wrap justify-center gap-3">
          <button
            onClick={() => scrollTo("#contacto")}
            className="inline-flex items-center gap-2 bg-[#C89B2C] hover:bg-[#A67D1F] text-[#0f172a] font-semibold px-7 py-3.5 rounded-sm transition-colors group"
            data-testid="cta-banner-schedule"
          >
            <Calendar size={18} />
            Agenda tu consulta
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </button>
          <a
            href={`https://wa.me/${CONTACT.whatsapp}?text=Hola%20Yohaly%2C%20quiero%20una%20consulta`}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#128C7E] text-white font-semibold px-7 py-3.5 rounded-sm transition-colors"
            data-testid="cta-banner-whatsapp"
          >
            <MessageCircle size={18} />
            WhatsApp
          </a>
          <a
            href={`tel:${CONTACT.phone1Tel}`}
            className="inline-flex items-center gap-2 bg-white hover:bg-white/90 text-[#0f172a] font-semibold px-7 py-3.5 rounded-sm transition-colors"
            data-testid="cta-banner-call"
          >
            <Phone size={16} />
            Llámanos
          </a>
        </div>
      </div>
    </section>
  );
}
